import { NgModule } from '@angular/core';

import { YucangooRatingComponent } from "./yucangoo-rating.component";
import { CommonModule } from "@angular/common";
import { RatingNotationModule } from "../rating-notation/rating-notation.module";

@NgModule({
    imports: [
        CommonModule,
        RatingNotationModule,
    ],
    exports: [
        YucangooRatingComponent
    ],
    declarations: [
        YucangooRatingComponent
    ],
    providers: [],
})
export class YucangooRatingModule {
}
